import { FC, Fragment } from 'react';
import { WhiteLabelAccessor } from 'utils/whiteLabelAccessor';
import { useUserActions } from 'store/reducers/auth/authReducer';
import {
  GenericErrorMessageText,
  GenericErrorMessageWrapper,
} from '@bookjane2/bookjane-design-library/lib/components/GenericErrorMessage/GenericErrorMessage.styled';
import { SadJaneIcon } from 'assets/SadJaneIcon';
import { isEnvDevelopment } from 'config';
import { BKJButton } from '@bookjane2/bookjane-design-library';

const AppErrorBoundaryWrapper = GenericErrorMessageWrapper as unknown as FC<{
  size: 'Small' | 'Medium' | 'Large';
  width?: string;
  height?: string;
  direction: 'column' | 'row';
}>;

export const AppErrorBoundary: FC<{ errorMessage?: string }> = ({ errorMessage, children }) => {
  const { isWhiteLabelled } = WhiteLabelAccessor;
  const showLogo = !isWhiteLabelled();

  const { userLogout } = useUserActions();

  const size = 'Medium';
  const direction = 'column';
  return (
    <AppErrorBoundaryWrapper size={size} width="100%" height="100%" direction={direction}>
      <Fragment>
        {showLogo && <SadJaneIcon direction={direction} />}
        {(process.env['NODE_ENV'] === 'development' || isEnvDevelopment) && errorMessage && (
          <GenericErrorMessageText size={size} direction={direction}>
            {errorMessage}
          </GenericErrorMessageText>
        )}

        <Fragment>
          <GenericErrorMessageText size={size} direction={direction}>
            Oops! Something went wrong
          </GenericErrorMessageText>
          <GenericErrorMessageText size={size} direction={direction}>
            Try refreshing the browser
          </GenericErrorMessageText>
        </Fragment>

        <BKJButton variant="PurpleSolid" onClick={() => userLogout()} width="180px">
          Logout
        </BKJButton>
      </Fragment>
    </AppErrorBoundaryWrapper>
  );
};
